import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/arrow-right-landing.svg'


const _hoisted_1 = {
  class: "wrapper",
  id: "contact-us-form"
}
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "input-wr textarea-wr" }
const _hoisted_14 = { class: "error-hint-wr" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "submit--icon",
  src: _imports_0
}
const _hoisted_18 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-wrapper" }, [
      _createElementVNode("p", { class: "title" }, "Contact us"),
      _createElementVNode("p", { class: "sub-title" }, "Got a question? Send us a message and our team will get back to you!")
    ], -1)),
    _createElementVNode("form", {
      class: "default-form",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.fullName.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.fullName) = $event)),
            type: "text",
            placeholder: "Full Name"
          }, null, 2), [
            [_vModelText, $setup.form.fullName]
          ]),
          ($setup.v$.fullName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.fullName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.email.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.email) = $event)),
            type: "text",
            placeholder: "Email Address"
          }, null, 2), [
            [_vModelText, $setup.form.email]
          ]),
          ($setup.v$.email.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode($setup["Cleave"], {
            class: _normalizeClass(["input", { error: $setup.v$.phone.$error }]),
            modelValue: $setup.form.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
            placeholder: "Phone Number",
            options: $setup.phoneNumberOption($setup.form.phone)
          }, null, 8, ["modelValue", "class", "options"]),
          ($setup.v$.phone.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.company.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.company) = $event)),
            type: "text",
            placeholder: "Company"
          }, null, 2), [
            [_vModelText, $setup.form.company]
          ]),
          ($setup.v$.company.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.v$.company.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("textarea", {
            class: "textarea",
            placeholder: "Message",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.message) = $event))
          }, null, 512), [
            [_vModelText, $setup.form.message]
          ]),
          _createElementVNode("div", _hoisted_14, [
            ($setup.v$.message.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.message.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "button default submit",
        onClick: $setup.submit,
        disabled: $setup.isSubmitting
      }, [
        _createTextVNode(_toDisplayString($setup.isSubmitting ? "Sending" : "Send Message"), 1),
        (!$setup.isSubmitting)
          ? (_openBlock(), _createElementBlock("img", _hoisted_17))
          : (_openBlock(), _createElementBlock("div", _hoisted_18))
      ], 8, _hoisted_16)
    ], 32)
  ]))
}